import { render, staticRenderFns } from "./CommentPop.vue?vue&type=template&id=60456ed4&scoped=true&"
import script from "./CommentPop.vue?vue&type=script&lang=ts&"
export * from "./CommentPop.vue?vue&type=script&lang=ts&"
import style0 from "./CommentPop.vue?vue&type=style&index=0&id=60456ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60456ed4",
  null
  
)

export default component.exports